import type { TrackingStats } from '~/gql/scorm/scorm'
import type { SessionParticipant } from '~/gql/sessions/sessions'
import { useTranslation } from 'react-i18next'
import { StatTile } from '~/components/StatTile'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'
import { tourAnchor } from '~/helpers/tour/anchors'
import CompletionBreakdown from '~/pages/backoffice/admin/dashboard/CompletionBreakdown'
import { statTiles } from '~/pages/backoffice/admin/dashboard/stat-tiles'
import { dropoutRate } from './participant-state'

/**
 * Indicateurs de la session (#243) : les compteurs du tableau de bord filtré
 * sur elle, lus par la même API et affichés par les mêmes composants.
 */
function SessionKpis({ stats, participants }: { stats: TrackingStats, participants: readonly Pick<SessionParticipant, 'droppedAt'>[] }) {
  const { t } = useTranslation()
  const tiles = statTiles(stats, t)
  const dropouts = dropoutRate(participants)

  return (
    <Card {...tourAnchor('sessionDetail.kpis')}>
      <CardHeader>
        <CardTitle className="text-lg">{t('sessionDetail.kpis.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-5">
        <CompletionBreakdown stats={stats} scopeLabel={t('sessionDetail.kpis.participants')} />
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
          <StatTile {...tiles.successRate} />
          <StatTile {...tiles.averageScore} />
          <StatTile {...tiles.averageTime} />
          <StatTile {...tiles.totalTime} />
          {/* La méthode sous le chiffre : Qualiopi (indicateur 2) demande de la publier (#324). */}
          <StatTile
            label={t('sessionDetail.kpis.dropoutRate')}
            value={dropouts == null ? '—' : `${dropouts} %`}
            hint={t('sessionDetail.kpis.dropoutMethod')}
          />
        </div>
      </CardContent>
    </Card>
  )
}

export default SessionKpis
